import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";
import { tabletViewport } from "@/utils/tabletViewport";

import { BrowseButton } from "../BrowseButton";
import { FileInput } from "../FileInput";
import { Text } from "../Text";
import { TextTypes, PopoverPositions } from "../constants";

import "./styles.scss";

export const UploadFile = ({
  className,
  disabled,
  files,
  infoContent,
  label,
  onBrowseButtonClicked,
  onFileDelete,
  placeholder,
  required,
  ...props
}) => {
  const windowWidth = window.innerWidth;

  return (
    <div className={createClassNameString(["apti-UploadFile", className])} {...props}>
      <div>
        <Text className="apti-UploadFile--header" type={TextTypes.label}>
          {label ? label : "Insurance Card Images"}
        </Text>

        {!required && (
          <Text className="apti-UploadFile--header" type={TextTypes.paragraph}>
            (Optional)
          </Text>
        )}
      </div>

      <div className="apti-UploadFile--input">
        <BrowseButton disabled={disabled} onClick={onBrowseButtonClicked} />
        <FileInput
          files={files}
          infoContent={infoContent}
          infoPopoverPosition={
            windowWidth < tabletViewport ? PopoverPositions.left : PopoverPositions.right
          }
          onDelete={onFileDelete}
          placeholder={placeholder ? placeholder : "Upload Insurance Card Image"}
        />
      </div>
    </div>
  );
};

UploadFile.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  files: PropTypes.arrayOf(PropTypes.string).isRequired,
  infoContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  label: PropTypes.string,
  onBrowseButtonClicked: PropTypes.func.isRequired,
  onFileDelete: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
};

UploadFile.defaultProps = {
  className: undefined,
  disabled: false,
  files: [],
  infoContent: undefined,
  label: undefined,
  onBrowseButtonClicked: () => {},
  onFileDelete: () => {},
  placeholder: undefined,
  requried: false,
};
